import { render } from "./detail.vue?vue&type=template&id=602ffd95&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=602ffd95&scoped=true&lang=css"
import "./detail.vue?vue&type=style&index=1&id=602ffd95&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602ffd95"]])

export default __exports__